import { createSelector } from "reselect"
import { get } from "lodash"
import { getAllAvailableRollups, getSelectedGroup as getRollupSelectedGroup } from "helpers/rollups"

const getRawSelectedGroup = state => get(state, "modules.compareFrontier.selectedGroup")
const getClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getSavedGroup = (state, props) => get(props, "savedGroup")
const getEndDate = (_, props) => get(props, "endDate")

export const getGroups = createSelector(
  [getClassifications, getEndDate],
  (classifications, date) =>
    getAllAvailableRollups({ classifications }, date),
)

export const getSelectedGroup = createSelector(
  [getGroups, getRawSelectedGroup, getSavedGroup],
  getRollupSelectedGroup,
)
